import { Obj, RecordStore } from '@deqo/foundation';
import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { StorageService } from '../../platform/StorageService';
import { SortMode } from '../common/Sorter';
import { AllBoardModel } from './AllBoardModel';

const template = {
    search: '',
    sort: ['lastSeenAt', 'desc'] as SortMode,
    items: [] as AllBoardModel[],
};

export class AllBoardsActiveViewModel extends RecordStore(template) {

    private canExtend = true;

    public static create(api: ApiClient, tempData: StorageService) {
        const m = new AllBoardsActiveViewModel(api, tempData);
        return [m, m.updateState.bind(m) as AllBoardsActiveViewModel['updateState']] as const;
    }

    constructor(private api: ApiClient, private tempData: StorageService) {
        super();
        this.updateState({
            ...(tempData.get('deqo/ui/allBoards') ?? {}),
        });
    }

    public async refresh(opts: { search?: string, sort?: SortMode } = {}) {

        this.updateState({
            search: opts.search ?? this.search,
            sort: opts.sort ?? this.sort,
            items: [],
        });

        this.tempData.put('deqo/ui/allBoards', Obj.pick(this.getState(), 'sort'));

        this.updateState({
            items: await this.fetch(0),
        });

        this.canExtend = true;
    }

    public async extend() {
        if (!this.canExtend) return;

        const next = await this.fetch(this.items.length);

        this.canExtend = next.length > 0;
        this.updateState({ items: this.items.concat(next) });
    }

    private async fetch(offset: number) {
        const items = await this.api.exec(v2.boards.list({
            search: this.search,
            mode: 'visited',
            sort: this.sort.join(':'),
            offset: offset.toString(),
            limit: '20',
        }));

        return items.map(x => AllBoardModel.create(x));
    }
}
